"use client";
import {axiosInstance} from "@/app/api";
import {
  calcTime,
  constractSwipesStr,
  convertMTOKM,
  formatDateCommon,
  formatDateTime,
  onGetTableResponse
} from "@/libs/helper";

const onGetDashboardDatas = async (requestdata: any): Promise<any> => {
  return await axiosInstance()
    .post(`/api/dashboard`, requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

const onGetDashboardReportData = async (
  url: string,
  body: any
): Promise<any> => {
  const TripStatusData: any = {
    "1": "YET TO START",
    "2": "IN PROGRESS",
    "3": "COMPLETED",
    "4": "NOT COMPLETED"
  };
  const StatusData: any = {
    "1": "Active",
    "2": "Expired",
    "3": "No Data",
    "4": "Expiring Soon"
  };

  const AttendanceStatusData: any = {"0": "Absent", "1": "Present"};
  return await axiosInstance()
    .post(url, body)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        var endPointData = neoresponse?.data?.reportData;
        var reportCommonHeader = neoresponse?.data;

        const reportCommonHeaders: any = {};
        if (reportCommonHeader?.vehicleName) {
          reportCommonHeaders.vehicleName = reportCommonHeader.vehicleName;
        }
        if (reportCommonHeader?.threshold) {
          reportCommonHeaders.threshold = reportCommonHeader.threshold;
        }

        const rows: any = [];
        endPointData.forEach((row: any) => {
          if (row?.date) {
            row.date = formatDateCommon(row?.date); //change the format like Dec
          } else {
            row.date = "N/A";
          }
          if (reportCommonHeaders.vehicleName) {
            row.vehicleName = reportCommonHeaders.vehicleName;
          }
          if (reportCommonHeaders.threshold) {
            row.threshold = reportCommonHeaders.threshold;
          }
          /*Vehicle Status Response Value Convertion Start*/
          if (row?.lastContactTime) {
            const lastContactTime = calcTime(row?.lastContactTime);
            // const [datePart, timePart] = lastContactTime.split(", ");
            row.lastContactTime = lastContactTime;
          } else {
            row.lastContactTime = "N/A";
          }
          /*Vehicle Status Response Value Convertion End*/

          /*Trip Status Response Value Convertion Start*/
          if (row?.tripStartTime) {
            const tripStartTime = calcTime(row?.tripStartTime);
            const [datePart, timePart] = tripStartTime.split(", ");
            row.tripStartTime = timePart;
          } else {
            row.tripStartTime = "N/A";
          }

          if (row?.tripEndTime) {
            const tripEndTime = calcTime(row?.tripEndTime);
            const [datePart, timePart] = tripEndTime.split(", ");
            row.tripEndTime = timePart;
          } else {
            row.tripEndTime = "N/A";
          }

          if (row?.tripType && row?.tripType == 1) {
            row.tripType = "Drop";
          } else {
            row.tripType = "Pickup";
          }
          /*Attendance Status Response Value Convertion Start*/
          if (row?.attendance_status && row?.attendance_status == 1) {
            row.attendance_status = "Present";
          } else {
            row.attendance_status = "Absent";
          }
          if (row?.tripStatus && TripStatusData[row?.tripStatus]) {
            const tripStatus = TripStatusData[row?.tripStatus];
            row.tripStatus = tripStatus;
          } else {
            row.tripStatus = "N/A";
          }
          /*Trip Status Response Value Convertion End*/

          /*Distance Driven Response Value Convertion Start*/
          if (row?.scheduled) {
            row.scheduled = convertMTOKM(row?.scheduled);
          } else {
            row.scheduled = "0 Km";
          }

          if (row?.unScheduled) {
            row.unScheduled = convertMTOKM(row?.unScheduled);
          } else {
            row.unScheduled = "0 Km";
          }
          /*Distance Driven Response Value Convertion End*/

          /*Distance Deviation Response Value Convertion Start*/
          // if (row?.totalDistance) {
          //   row.totalDistance = convertMTOKM(row?.totalDistance);
          // } else {
          //   row.totalDistance = "0 Km";
          // }

          if (row?.deviationTime && row?.threshold) {
            row.thresholdStr = convertMTOKM(row?.threshold);
          }

          if (row?.deviationTime) {
            // const deviationTime = calcTime(row?.deviationTime);
            // const [datePart, timePart] = deviationTime.split(", ");
            row.deviationTime = formatDateTime(row?.deviationTime);
          } else {
            row.deviationTime = "N/A";
          }

          /*Distance Deviation Response Value Convertion Start*/

          /*Bus Attendance Response Value Convertion Start*/
          if (row?.swipes && row?.status && AttendanceStatusData[row?.status]) {
            row.status = AttendanceStatusData[row?.status];
          } else if (
            row?.swipes &&
            row?.status == 0 &&
            AttendanceStatusData[row?.status]
          ) {
            row.status = AttendanceStatusData[row?.status];
          }
          /* status Condition for Permit , Insurance Start*/
          if (row?.validUpto) {
            const validUpto = formatDateCommon(row?.validUpto);
            row.validUpto = validUpto;
          } else {
            row.validUpto = "N/A";
          }
          if (StatusData[row?.status]) {
            const tripStatus = StatusData[row?.status];
            row.status = tripStatus;
          } else {
            row.status = "N/A";
          }
          /* status Condition for Permit , Insurance End*/

          let in_pick_time = "";
          let out_drop_time = "";
          let other_swipes_time = "";

          if (row?.swipes) {
            row?.swipes.forEach((swipedatas: any) => {
              const triptype = swipedatas?.type;
              if (triptype == 1) {
                out_drop_time = constractSwipesStr(swipedatas);
              } else {
                in_pick_time = constractSwipesStr(swipedatas);
              }
            });
            row.in_pick_time = in_pick_time;
            row.out_drop_time = out_drop_time;
          }

          if (row?.otherSwipes) {
            row?.otherSwipes.forEach((swipedatas: any, index: number) => {
              // other_swipes_time = constractSwipesStr(swipedatas);  const swipeText = constractSwipesStr(swipedatas);
              const swipeText = constractSwipesStr(swipedatas);
              other_swipes_time += index === 0 ? swipeText : " - " + swipeText;
            });
            row.other_swipes_time = other_swipes_time;
          }
          /*Bus Attendance Response Value Convertion End*/

          /*Insurance,Permit,Pollution Last updated Date Conversion Start*/
          if (row?.updatedDt) {
            const updatedDt = formatDateCommon(row?.updatedDt);
            row.updatedDtString = updatedDt;
          } else {
            row.updatedDtString = "N/A";
          }
          /*Insurance,Permit,Pollution Last updated Date Conversion End*/
          rows.push({...row});
        });
        return {
          columns: neoresponse?.data?.columns,
          reportCommonHeaders: reportCommonHeaders,
          rows: rows,
          meta: neoresponse?.meta
        } as TableResponse<any>;
      }
      return onGetTableResponse();
    })
    .catch((error: any) => {
      return onGetTableResponse();
    });
};

const onGetSettingDatas = async (): Promise<any> => {
  return await axiosInstance()
    .get(`/api/user/settings`)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

const onSaveUserSetting = async (requestdata: any): Promise<any> => {
  return await axiosInstance()
    .post(`/api/save/user/settings`, requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};
const onCustomExpenseData = async (requestdata: any): Promise<any> => {
  return await axiosInstance()
    .post(`/api/fleet/expense/summary`, requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

const onCustomFuelTheftRefilling = async (requestdata: any): Promise<any> => {
  return await axiosInstance()
    .post(`/api/fuel/summary`, requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

const onGetMappedDetails = async (requestdata: any): Promise<any> => {
  return await axiosInstance()
    .post(`/api/mappedDetails`, requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

const onSubmitFeatureRequest = async (requestdata: any): Promise<any> => {
  return await axiosInstance()
    .post(`/api/featureRequest`, requestdata)
    .then((response: any) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const NeoDashboardService = {
  onGetDashboardDatas,
  onGetDashboardReportData,
  onGetSettingDatas,
  onSaveUserSetting,
  onCustomExpenseData,
  onCustomFuelTheftRefilling,
  onGetMappedDetails,
  onSubmitFeatureRequest
};
